export default {
  /**
   *
   * @param state
   * @returns {boolean}
   */
  overlayIsActive: (state) => Boolean(state.activeAppModal || state.activeAppTray || state.activeFlyIn),
}
